import produce from 'immer';
import { Actions } from './action';
import { AppAction } from './enum';
import { AppState } from './interface';

export const initialState: AppState = {
    loadingStatus: {},
    currentLevelId: '',
    routingPath: [],
};

const appReducer = (state: AppState = initialState, action: Actions) =>
    produce(state, draft => {
        switch (action.type) {
            case AppAction.InitStore:
                draft.currentLevelId = action.state.currentLevelId ?? draft.currentLevelId;
                draft.routingPath = [draft.currentLevelId];
                break;
            case AppAction.StartLoading:
                draft.loadingStatus[action.id] = true;
                break;
            case AppAction.StopLoading:
                delete draft.loadingStatus[action.id];
                break;
            case AppAction.SetError:
                draft.error = action.error;
                break;
            case AppAction.StepToNextLevel:
                draft.currentLevelId = action.levelId;
                draft.routingPath.push(action.levelId);
                break;
            case AppAction.StepBack: {
                (draft.routingPath.length !== 1) && draft.routingPath.pop();
                draft.currentLevelId = draft.routingPath[draft.routingPath.length - 1];
                break;
            }
        }
    });

export default appReducer;
